/* eslint-disable import/order */
import React from 'react';
import { MenuIdProfile } from '@jira/navigation-apps__constants/src/MenuIdProfile.tsx';
import { SidebarIdPersonalSettings } from '@jira/navigation-apps__constants/src/SidebarIdPersonalSettings.tsx';
import type DigestsNotificationsPersonalSettingsType from '@jira/spa-apps__personal-settings-digests-notifications/src/ExportedDefault.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { digestsNotificationsPersonalSettingsRoute } from '@jira/router-routes__personal-settings-routes/src/digestsNotificationsPersonalSettingsRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyDigestsNotificationsPersonalSettings = lazyForPaint<
	typeof DigestsNotificationsPersonalSettingsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-personal-settings-digests", jiraSpaEntry: "async-personal-settings-digests" */ '@jira/spa-apps__personal-settings-digests-notifications/src/ExportedDefault.tsx'
			),
		),
	{
		ssr: false,
	},
);

const DigestsNotificationsPersonalSettingsComponent = () => (
	<LazyPage
		Page={LazyDigestsNotificationsPersonalSettings}
		pageId="personal-settings-notifications"
		shouldShowSpinner
	/>
);

export const digestsNotificationsPersonalSettingsRouteEntry: Route = createEntry(
	digestsNotificationsPersonalSettingsRoute,
	() => ({
		group: 'personal-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: DigestsNotificationsPersonalSettingsComponent,

		navigation: {
			sidebarId: SidebarIdPersonalSettings,
			menuId: MenuIdProfile,
		},

		resources: [...getNavigationResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyDigestsNotificationsPersonalSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
